import React, { useCallback } from 'react';
import { useNotify, useRecordContext } from 'react-admin';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import UserPicture from '../../../components/UserPicture/UserPicture';
import EditAvatarModal from './EditAvatarModal';
import uploadService from '../../../utils/upload';
import dataProvider from '../../../providers/dataProvider';

const UPDATE = 'UPDATE';

const updateUser = (values) => {
  return dataProvider(UPDATE, 'users', { id: values.id, data: values, previousData: values });
};

const GridProfile = () => {
  const record = useRecordContext();
  const notify = useNotify();

  const handleAvatar = useCallback(
    (img) => {
      if (typeof img.picture === 'object') {
        const formData = new FormData();
        formData.append('file', img.picture.rawFile);
        uploadService(formData)
          .then((res) => {
            if (!res?.data?.fileName) {
              throw new Error('Failed to upload image');
            }
            return updateUser({
              id: record.id,
              picture: res.data.fileName,
            });
          })
          .then(() => {
            notify('Profile picture updated successfully', { type: 'success' });
          })
          .catch((error) => {
            notify(error?.message || 'Failed to update profile picture', { type: 'error' });
          });
      }
    },
    [record?.id, notify],
  );

  if (!record) {
    return null;
  }

  return (
    <>
      <Grid container spacing={1}>
        <Grid size={{ md: 12 }}>
          <h2>My Profile</h2>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid size={{ md: 3 }}>
          <EditAvatarModal onSave={handleAvatar}>
            <UserPicture />
          </EditAvatarModal>
        </Grid>
        <Grid size={{ md: 9 }}>
          <Grid container spacing={1}>
            <Grid size={{ md: 9 }}>
              <Typography variant="title">{`${record.firstName} ${record.lastName}`}</Typography>
            </Grid>
            <Grid size={{ md: 9 }}>
              <Typography>Email: {record.email}</Typography>
            </Grid>
            <Grid size={{ md: 9 }}>
              <Typography>Password: ***********</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default GridProfile;
